import { styled } from 'styled-components';

import { colors, cssBreakpoints, spacing } from '#/theme/theme';

export const CmsBlockquoteBlock_Box_1 = styled.div`
  margin-left: -${spacing[24]};
  width: 100vw;
  background: ${colors.backgroundGrey};

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    width: 100%;
    margin-left: 0;
    border-radius: 10px;
  }
`;
